/**
 * 模板导入时为重复图层分配确定性 ID，避免覆盖其他页面或父组
 *
 * 在 server-to-client 收集全部页面的 ID 后调用，保持协同两端的修复结果一致。
 * 对齐 user-editor 同名模块。
 */
import { ParkMillerRandom } from '@meitu/saas-editor-core/es/utils/random-kit';
import type { ILayerProps } from '@meitu/saas-editor-core/es/version-types';

/**
 * 为重复图层分配未被文档占用的 ID，并同步直接子图层的父级引用
 *
 * 原地修改重复图层及其子图层，并将新 ID 加入已占用集合
 *
 * @param duplicateLayers - 按模板遍历顺序收集的重复图层，不包含首次出现的图层
 * @param usedLayerIds - 全部页面已占用的 ID，必须在修复前完成收集
 */
export function resetDuplicateLayerIds(duplicateLayers: ILayerProps[], usedLayerIds: Set<string>): void {
    // 保留原有种子，确保同一份模板在不同协同客户端得到相同结果。
    const random = new ParkMillerRandom(3003);
    duplicateLayers.forEach((layer) => {
        let newLayerId: string;
        do {
            newLayerId = `pmr-${random.randomString()}`;
        } while (usedLayerIds.has(newLayerId));

        usedLayerIds.add(newLayerId);
        layer.id = newLayerId;
        layer.children?.forEach((childLayer) => {
            childLayer.parentId = newLayerId;
        });
    });
}
